import { render } from "./ImageBox.vue?vue&type=template&id=71c91531"
import script from "./ImageBox.vue?vue&type=script&lang=js"
export * from "./ImageBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__